import { supabase } from '../../../lib/supabase'

export interface AdminAccount {
  name: string
  email: string
}

export async function getActiveAdminAccount(userId: string): Promise<AdminAccount | null> {
  const { data: adminAccount, error } = await supabase
    .from('admin_accounts')
    .select('name, email')
    .eq('id', userId)
    .eq('status', 'active')
    .maybeSingle()

  if (error || !adminAccount) return null

  return adminAccount
}

export async function isActiveAdminAccount(userId: string) {
  return Boolean(await getActiveAdminAccount(userId))
}
